<template lang="pug">
  .gl-blank-state(layout="column" layout-align="start center")
    .gl-blank-state__container
      .gl-blank-state__content
        .gl-blank-state__circle(layout="column" layout-align="center center")
          font-awesome-icon.gl-blank-state__circle__fa(:icon="options.icon")
        .gl-blank-state__body
          .gl-blank-state__title {{ options.title }}
          .gl-blank-state__description(v-html="options.description")

</template>

<script>

export default {

  // props
  props: {
    options: Object
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/colors';
  @import '../styles/variables';

  .gl-blank-state {
    margin: 0 auto;
    padding-top: 66px;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    text-align: center;

    &__container {
      padding: 40px 0;
      overflow: auto;
      height: 100%;
      width: 100%;
    }

    &__circle {
      margin: 0 auto;
      background: rgba($gl-grey-border, 0.5);
      border-radius: 50%;
      width: 140px;
      height: 140px;

      &__fa {
        font-size: 90px;

        @media (max-width: 960px) {
          font-size: 70px;
        }
      }

      @media (min-width: 960px) {
        width: 200px;
        height: 200px;
      }
    }

    &__body {
      text-align: center;

      button {
        margin: 0 auto;
      }
    }

    &__title {
      margin: 24px auto 12px auto;
      font-size: 26px;
      font-weight: 700;

      @media (min-width: 960px) {
        font-size: 30px;
      }
    }

    &__description {
      line-height: 1.2;
      margin: 0 auto 14px auto;
      max-width: 430px;

      @media (min-width: 960px) {
        font-size: 18px;
      }
    }

    &__btn {

      button {
        margin: 0 auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gl-blank-state.vue